module.exports = __webpack_public_path__ + "static/media/IMG_1.d35a3a68.jpg";